import { render } from "./page5.vue?vue&type=template&id=5dd90c49&scoped=true"
import script from "./page5.vue?vue&type=script&lang=js"
export * from "./page5.vue?vue&type=script&lang=js"

import "./page5.vue?vue&type=style&index=0&id=5dd90c49&scoped=true&lang=less"

import exportComponent from "D:\\work\\mvgx-carbon-space-admin-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd90c49"]])

export default __exports__